import { render, staticRenderFns } from "./Kontaktformular.vue?vue&type=template&id=77aa96bc"
import script from "./Kontaktformular.vue?vue&type=script&lang=js"
export * from "./Kontaktformular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports